<template>
  <div class="row">
    <div class="col">
      <div class="card bg-white">
        <div class="card-header bg-gray-100">
          <p class="text-semibold no-margin">
            Motorista
          </p>
          <div class="heading-elements">
            <i
              class="fas fa-long-arrow-alt-left position-left"
              @click="voltar()"
              style="cursor: pointer"
            ></i>
          </div>
        </div>
        <div class="box-body">
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label for="file"
                >Escolhe um arquivo CSV <sup class="text-danger">* </sup></label
              >
              <input id="file" type="file" name="file" ref="files" />
              <br />
              <div class="alert-info" style="padding: 10px 0 10px 10px">
                As linhas do arquivo CSV deve ser separado por "," !
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-12 col-md-6">
              <label slot="ativo">Arquivo incremental </label>
                <toggle-button
                  v-model="tipoArquivo"
                  :color="{
                    checked: 'red',
                    unchecked: '#75c791'
                  }"
                />
              <label slot="ativo">Arquivo base</label>
            </div>
          </div>
        </div>
              
        <div class="box-footer text-center">
          <div class="btn-group">
            <button
              type="button"
              id="cancelButton"
              class="btn btn-warning"
              @click="voltar()"
            >
              Cancelar
            </button>
            <button
              type="button"
              id="gravarButton"
              class="btn btn-success"
              @click="gravar()"
            >
              Gravar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue'
import MotoristaActions from "../../actions/MotoristaActions";
import ToggleButton from 'vue-js-toggle-button'

Vue.use(ToggleButton)

export default {
  name: "Importar",
  data() {
    return {
      errorMessage: "",
      tipoArquivo: false
    };
  },
  mounted() {
    this.$parent.$parent.$data.description = "Importar";
  },
  methods: {
    voltar() {
      this.$router.push("/motoristas/listar-ativos");
    },
    async gravar() {
      this.$parent.$parent.$data.showModalLoader = true;
      this.errorMessage = "";
      let dataForm = new FormData();
      for (let file of this.$refs.files.files) {
        dataForm.append("file", file);
        dataForm.append("tipo_arquivo", this.tipoArquivo ? 2 : 1);
      }
      await MotoristaActions.importarCSV(
        { dataForm },
        this,
        "motoristas/listar-ativos",
        "AUTH0_CONNECTION_DB_PWADRIVER"
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/motorista/Importar.vue